import { render, staticRenderFns } from "./ListPropagandaElectoral.vue?vue&type=template&id=04f998ce&scoped=true&"
import script from "./ListPropagandaElectoral.vue?vue&type=script&lang=js&"
export * from "./ListPropagandaElectoral.vue?vue&type=script&lang=js&"
import style0 from "./ListPropagandaElectoral.vue?vue&type=style&index=0&id=04f998ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f998ce",
  null
  
)

export default component.exports